import { useState } from "react";
import { toast } from "sonner";
import { Mail } from "lucide-react";
import { api } from "../lib/api";

export function NewsletterForm({ source = "footer" }) {
    const [email, setEmail] = useState("");
    const [busy, setBusy] = useState(false);
    const [done, setDone] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (!email.trim()) return;
        setBusy(true);
        try {
            const { data } = await api.post("/newsletter/subscribe", { email: email.trim().toLowerCase(), source });
            setDone(true);
            if (data.duplicate) toast.success("You're already subscribed — welcome back!");
            else toast.success("Subscribed! Atelier letters incoming.");
            setEmail("");
            // re-enable after 4s
            setTimeout(() => setDone(false), 4000);
        } catch (_e) {
            toast.error("Could not subscribe. Please try a valid email.");
        } finally {
            setBusy(false);
        }
    };

    return (
        <form onSubmit={submit} className="flex flex-col sm:flex-row gap-2 max-w-md" data-testid={`newsletter-form-${source}`}>
            <div className="flex-1 flex items-center gap-2 rounded-full bg-ivory border border-inkDark/10 px-4 py-2.5 focus-within:border-skyblueDeep">
                <Mail size={16} className="text-inkMuted" />
                <input
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="your@email.com"
                    className="flex-1 bg-transparent outline-none text-inkDark placeholder:text-inkMuted/70 text-sm"
                    data-testid={`newsletter-email-${source}`}
                />
            </div>
            <button
                type="submit"
                disabled={busy || done}
                className="btn-pill text-sm disabled:opacity-50"
                data-testid={`newsletter-submit-${source}`}
            >
                {done ? "Subscribed" : busy ? "Sending…" : "Subscribe"}
            </button>
        </form>
    );
}
